import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { AppSettingsActionTypeEnum, useAppSettings } from "../../contexts/app-context/AppContext";
import SideSheet from "../side-sheet/side-sheet/SideSheet";

export type OptionsSideSheetProps = {
    onReset?: () => void;
};

export default function OptionsSideSheet({
    onReset,
    children
}: PropsWithChildren<OptionsSideSheetProps>) {

    const [appSettings, dispatchAppSettings] = useAppSettings();
    const { t } = useTranslation();

    const open = appSettings.sideSheetOpen;

    function onClose() {
        dispatchAppSettings({
            type: AppSettingsActionTypeEnum.SideSheetOpenChanged,
            open: false
        });
    }

    return (
        <SideSheet
            title={t("options")}
            open={open}
            onClose={onClose}
            onReset={onReset}
            
        >
            {children}
        </SideSheet>
    );
}
